import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "295",
  "slug": "spot-netherlands-from-satellite-imagery",
  "title": "How to Recognise the Netherlands in Satellite Images",
  "excerpt": "The Rhine-Meuse delta, IJsselmeer, and North Sea coast help orient a regional view of the Netherlands.",
  "date": "2026-04-23",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/netherlands.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "The Rhine-Meuse delta, IJsselmeer, and North Sea coast help orient a regional view of the Netherlands. In closer imagery, canals, drainage ditches, and rectilinear parcels may reveal managed lowland. Large water bodies and coastal barriers provide more context than a single green field."
    },
    {
      "type": "heading",
      "text": "Delta waterways and reclaimed land"
    },
    {
      "type": "paragraph",
      "text": "Find IJsselmeer and the adjoining reclaimed land. Trace the straight embankments and compare them with the more irregular coast farther north."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Northern Germany and Belgium share flat agricultural areas, canals, and dense road networks. Reclaimed land also exists elsewhere. Compare the arrangement of major waterways before using a drainage pattern to select the Netherlands."
    }
  ],
  "imageAlt": "the Netherlands regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
